angular.module('cian.ui.selectpopup', [])
	.config(["$interpolateProvider", function ($interpolateProvider) {
		$interpolateProvider.startSymbol('{$');
		$interpolateProvider.endSymbol('$}');
	}]);

angular.module('cian.ui.selectpopup')
	.directive('selectpopup', ["$document", "$sce", "$timeout", function ($document, $sce, $timeout) {
		return {
			scope: {
				items: '=',
				source: '=',
				appearance: '@',
				classes: '@?',
				onChange: '&?',
				sortingQuality: '='
			},
			template: require('./selectpopup.html'),
			replace: true,
			link: function (scope, elem) {
				scope.isOpen = false;

				scope.$watch('items', function (newItems) {
					// Для объектов добавляем JSON для использования в track by
					scope.itemsWithTracking = newItems.map(function (item) {
						return angular.extend({}, item, {
							trackValue: angular.isObject(item.value) ? angular.toJson(item.value) : item.value
						})
					});
				});

				scope.isLink = function () {
					return scope.appearance === 'link';
				};

				// Convert text to html (to use <sup>)
				scope.getHtml = function (item) {
					item.html = item.html || $sce.trustAsHtml(item.text);
					return item.html;
				}

				// Подставляем в название текущее значение
				scope.getTitle = function () {
					var currentIndex = scope.items.findIndex(function (item) {
						return item.value === scope.source;
					});
					if (currentIndex > -1) {
						var currentItem = scope.items[currentIndex];
						return currentItem.title || scope.getHtml(currentItem);
					}
				};

				scope.selectItem = function (newItem) {
					if (!angular.equals(newItem.value, scope.source)) {
						scope.source = newItem.value;
						triggerChange();
					}

					scope.toggle();
				};

				scope.toggleQuality = function () {
					scope.toggle();
					triggerChange();
				};

				function triggerChange() {
					if (scope.onChange) {
						$timeout(scope.onChange, 0);
					}
				}

				scope.isActive = function (item) {
					return item.value === scope.source;
				};

				scope.toggle = function () {
					if (!scope.isOpen) {
						$document.on('click', checkOutsideClick);
					} else {
						unsubscribe();
					}

					scope.isOpen = !scope.isOpen;
				};

				var checkOutsideClick = function (e) {
					var isInside = elem.find(e.target).length || elem.is(e.target);

					if (!isInside) {
						scope.toggle();
						scope.$apply();
					}
				};

				var unsubscribe = function () {
					$document.off('click', checkOutsideClick);
				};

				scope.$on('$destroy', unsubscribe);
			}
		}
	}]);



//////////////////
// WEBPACK FOOTER
// ../components/ui/src/selectpopup/selectpopup.js
// module id = 910
// module chunks = 0